import React from 'react';
import Frontpage from '@fuww/library/src/Frontpage';
import ArticleLayout from './News/ArticleLayout';
import Head from './Head';
import HomeLink from './HomeLink';
import LinkAndAnchor from './LinkAndAnchor';

const ThirdPartyContent = ({
  title,
  description,
  route,
  newsVariables,
}: {
  title: string;
  description: string;
  route: string;
  newsVariables: Record<string, unknown>;
}) => {
  const breadcrumbs = [
    <HomeLink />,
    <LinkAndAnchor
      route={route}
      passHref
    >
      {title}
    </LinkAndAnchor>,
  ];

  return (
    <>
      <Head
        title={title}
        description={description}
      />
      <Frontpage
        breadcrumbs={breadcrumbs}
        intro={description}
        mainSection={(
          <ArticleLayout featuredVariables={newsVariables} />
        )}
      />
    </>
  );
};

export default ThirdPartyContent;
